import { useState, useEffect, useRef, Fragment } from "react"
import { Grid } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";

import { useIntl } from "react-intl";
//Components
import { SidePanel, Button, Select, Checkbox, Input, Form, ToggleSwitch, RadioButton } from "@gpstrackit/react-controls";
import InputDate from 'Components/InputDate';

import {
    searchEntityRequest,
    clearRedux
} from "Redux/actions";

import CustomSelect from 'Components/Select';
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import { sub } from "date-fns";
import { getDateRangeOptions, getEventsTypes } from '../../../../core/data/Helpers';


const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, loading, values, setValues, report, params, setRecreateGrid } = props;
    const { messages } = useIntl();
    const formRef = useRef();
    const dispatch = useDispatch();

    const requestSubmitAction = (intent, exportType = null) => {
        if (props.onRequestSubmitAction) {
            props.onRequestSubmitAction(intent, exportType);
        }
    };

    //Redux States
    const dealers = useSelector(state => state.generalRedux.dealers);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const tags = useSelector(state => state.generalRedux.tags);
    const subUsers = useSelector(state => state.generalRedux.subUsers);
    const loadingEntity = useSelector(state => state.generalRedux.loadingEntity);

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const getInput = (reportParam) => {
        reportParam.param = params?.find(x => x.id === reportParam.paramId)
        if (!reportParam?.param?.paramKey) {
            return null;
        }
        let param = values && values.find(x => x.paramKey === reportParam?.param?.paramKey);
        switch (reportParam.param.paramKey) {
            case "dealerId":
                return (
                    <Select
                        id="dealer-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param.paramValue && param.paramValue !== -1 ? param : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.id;

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.name = value.name
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.name = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, name: value.name })
                            }

                            let paramAccount = vals && vals.find(x => x.paramKey === "accountId");

                            if (paramAccount) {
                                let indexAcc = vals.indexOf(paramAccount);
                                vals[indexAcc].paramValue = -1;
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={loadingEntity}
                        options={dealers}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="name"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                    />
                );
                break;
            case "manufacturerId":
                let manufac = manufacturers.find(x => x.id === param?.paramValue)
                if (manufac)
                    param.name = manufac.name

                return (
                    <Select
                        id="manufacturer-list"
                        label={messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param.paramValue && param.paramValue !== -1 ? param : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.id;

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.name = value.name
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.name = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, name: value.name })
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={loadingEntity}
                        options={manufacturers}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="name"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                    />
                );
            case "tagIds":
                let tagsIds = []
                if (param?.paramValue !== -1)
                    tagsIds = param?.paramValue?.split(",")?.map(x => parseInt(x)) || [];
                return (
                    <Select
                        id="tags-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param.paramValue && param?.paramValue !== -1 && tagsIds.length > 0 ? tags.filter(x => tagsIds.includes(x.id)) : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.map(x => x.id).join(",");

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.label = value.label
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.label = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, label: value.label })
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={loadingEntity}
                        options={tags}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="label"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                        multiple
                    />
                );
                break;
            case "dateRangeBy":
                return (
                    <Select
                        id="dealer-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param.paramValue && param.paramValue !== -1 ? param : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.id;

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.label = value.label
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.label = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, label: value.label })
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={false}
                        options={getDateRangeOptions(messages)}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="label"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                    />
                );
            case "reviewedBy":
                let accountParam = values?.find(x => x.paramKey === "accountId");
                let isMultipleReviewedBy = report?.reportKey === "video_review_bycompany_v2";
                
                // Opción especial "All" para selección múltiple
                const ALL_OPTION = { userName: "All", id: "ALL" };
                
                // Para selección múltiple: convertir string separado por comas a array
                let reviewedByUsers = [];
                if (isMultipleReviewedBy && param?.paramValue && param?.paramValue !== -1) {
                    let userNames = param.paramValue.split(",");
                    let userIds = param.id?.toString().split(",") || [];
                    reviewedByUsers = userNames.map((userName, index) => {
                        let userId = userIds[index];
                        // Si es "All", mantener como string, si no, convertir a número
                        if (userName === "All" || userId === "ALL") {
                            return { userName: "All", id: "ALL" };
                        }
                        return {
                            userName: userName,
                            id: isNaN(userId) ? userId : parseInt(userId)
                        };
                    });
                }

                // Preparar opciones con "All" al inicio si es selección múltiple
                let reviewedByOptions = accountParam 
                    ? [{ userName: accountParam.username, id: accountParam.id }, ...subUsers] 
                    : subUsers;
                
                if (isMultipleReviewedBy) {
                    reviewedByOptions = [ALL_OPTION, ...reviewedByOptions];
                }

                return (
                    <Select
                        id="reviewed-by-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={
                            isMultipleReviewedBy
                                ? (param && param.paramValue && param.paramValue !== -1 && reviewedByUsers.length > 0
                                    ? reviewedByOptions.filter(user => 
                                        reviewedByUsers.some(selected => 
                                            String(selected.id) === String(user.id)
                                        )
                                    )
                                    : null)
                                : (param && param.paramValue && param.paramValue !== -1 ? param : null)
                        }
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;

                            if (isMultipleReviewedBy) {
                                // Manejo para selección múltiple con lógica de "All"
                                let valueUserNames = -1;
                                let valueIds = -1;
                                let finalValue = value || [];

                                if (value && value.length > 0) {
                                    // Verificar si "All" está en la selección actual
                                    const allSelected = value.some(v => String(v.id) === "ALL");
                                    // Verificar si "All" estaba en la selección previa
                                    const previousAllSelected = reviewedByUsers.some(u => String(u.id) === "ALL");

                                    // Caso 1: Si "All" fue recién seleccionado, solo dejar "All"
                                    if (allSelected && !previousAllSelected) {
                                        finalValue = [ALL_OPTION];
                                    } 
                                    // Caso 2: Si "All" estaba seleccionado y ahora hay más elementos, remover "All" y dejar los demás
                                    else if (previousAllSelected && allSelected && value.length > 1) {
                                        finalValue = value.filter(v => String(v.id) !== "ALL");
                                    }
                                    // Caso 3: Comportamiento normal (selección múltiple de usuarios sin "All")
                                    // finalValue ya es igual a value

                                    valueUserNames = finalValue.map(x => x.userName).join(",");
                                    valueIds = finalValue.map(x => x.id).join(",");
                                }

                                if (param) {
                                    index = vals.indexOf(param);
                                    if (finalValue && finalValue.length > 0) {
                                        param.paramValue = valueUserNames;
                                        param.id = valueIds;
                                        param.userName = valueUserNames;
                                    } else {
                                        param.paramValue = -1;
                                        param.id = -1;
                                        param.userName = null;
                                    }
                                    vals[index] = param;
                                } else {
                                    vals.push({
                                        paramValue: valueUserNames,
                                        paramKey: reportParam.param.paramKey,
                                        id: valueIds,
                                        userName: valueUserNames
                                    });
                                }
                            } else {
                                // Manejo para selección única (comportamiento original)
                                let valueId = -1;
                                if (value)
                                    valueId = value.id;

                                if (param) {
                                    index = vals.indexOf(param);
                                    if (value) {
                                        param.paramValue = value.userName;
                                        param.id = valueId;
                                        param.userName = value.userName;
                                    } else {
                                        param.paramValue = -1;
                                        param.id = -1;
                                        param.userName = null;
                                    }
                                    vals[index] = param;
                                } else {
                                    vals.push({
                                        paramValue: value.userName,
                                        paramKey: reportParam.param.paramKey,
                                        id: valueId,
                                        userName: value.userName
                                    });
                                }
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);
                        }}
                        isLoading={loadingEntity}
                        options={reviewedByOptions}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="userName"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                        multiple={isMultipleReviewedBy}
                    />
                );
                break;
            case "deviceModelId":

                let manufacturer = values.find(x => x?.paramKey === "manufacturerId" && x?.paramValue !== -1)
                let devModels = []
                if (manufacturer) {
                    devModels = deviceModels.filter(x => x.manufacturerId = manufacturer?.paramValue)
                    let devModel = devModels.find(x => x.id === param?.paramValue)
                    if (devModel)
                        param.name = devModel.name
                }

                return (
                    <Select
                        id="device-model-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param?.paramValue && param?.paramValue !== -1 ? param : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.id;

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.name = value.name
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.name = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, name: value.name })
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={loadingEntity}
                        options={devModels}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="name"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                    />
                );
                break;
            case "accountId":
                return (
                    <CustomSelect
                        async
                        value={param?.paramValue === -1 ? null : param}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            if (param) {
                                index = values.indexOf(param);
                                if (value) {
                                    param.paramValue = value.id;
                                    param.id = value.id;
                                    param.name = value.name;
                                    param.username = value.username;

                                    vals[index] = param;
                                } else {
                                    if (!reportParam.required) {
                                        param.paramValue = -1;
                                        param.id = -1;
                                        param.name = null;
                                        vals[index] = param;
                                    } else {
                                        vals.splice(index, 1);
                                    }
                                }

                            } else {
                                vals.push({ paramValue: value.id, paramKey: reportParam.param.paramKey, id: value.id, name: value.name, username: value.username })
                            }
                            if (report.reportParams?.find(x => x.param.paramKey === "reviewedBy")) {
                                if (value)
                                    dispatch(searchEntityRequest({ key: "subUsers", companyId: value?.id }));
                                else
                                    dispatch(clearRedux("GENERAL", { subUsers: [] }));
                            }
                            setValues([...vals])
                        }
                        }
                        label={messages['devices_bulk_actions_account']}
                        placeholder={messages['devices_bulk_actions_account']}
                        loadOptions={getAccountsForSelect}
                        loading={loadingEntity}
                        required={reportParam.required}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e.id}
                    />
                )
                break;
            case "afterBeforeFlag":
                let paramDate = values && values.find(x => x.paramKey === "afterBeforeCreationDate");
                let value = false;
                if (param && param.paramValue && param.paramValue !== -1)
                    value = true;
                let valueParamDate = new Date();
                if (paramDate && paramDate.paramValue && paramDate.paramValue !== -1)
                    valueParamDate = paramDate.paramValue;

                return (
                    <Fragment>
                        {
                            <div>
                                <div className="d-flex">
                                    <div >
                                        <Checkbox
                                            id={`checkbox_${reportParam.param.paramKey}`}
                                            label={messages['report_overview_creation_date_filter']}
                                            value={value}
                                            onChange={(val) => {

                                                let vals = values;
                                                let index = -1;
                                                let indexParamDate = -1;
                                                if (param) {
                                                    index = vals.indexOf(param);
                                                    indexParamDate = vals.indexOf(paramDate);
                                                    param.paramValue = val ? "1" : -1;
                                                    vals[index] = param;
                                                    if (param.paramValue === -1) {
                                                        if (paramDate) {
                                                            paramDate.paramValue = -1;
                                                            vals[indexParamDate] = paramDate;
                                                        }
                                                    } else {
                                                        if (paramDate) {
                                                            paramDate.paramValue = new Date();
                                                            values[indexParamDate] = paramDate;
                                                        } else {
                                                            vals.push({ paramValue: new Date(), paramKey: "afterBeforeCreationDate" })
                                                        }
                                                    }
                                                } else {
                                                    vals.push({ paramValue: "1", paramKey: reportParam.param.paramKey })
                                                    vals.push({ paramValue: new Date(), paramKey: "afterBeforeCreationDate" })
                                                }
                                                setValues([...vals]);
                                            }}
                                        />
                                    </div>
                                </div>
                                {
                                    param && param.paramValue && param.paramValue !== -1 &&
                                    <div className="d-flex" style={{ marginTop: "15px" }}>
                                        <div style={{ width: "50%" }}>
                                            <RadioButton
                                                onChange={(value) => {

                                                    let vals = values;
                                                    let index = -1;
                                                    if (param) {
                                                        index = vals.indexOf(param);
                                                        param.paramValue = "0";
                                                        vals[index] = param;
                                                    } else {
                                                        vals.push({ paramValue: value, paramKey: reportParam.param.paramKey })
                                                    }
                                                    setValues([...vals])
                                                }}
                                                value={param?.paramValue === "0"}
                                                label={messages['report_overview_after']}
                                                position="end"
                                            />
                                        </div>
                                        <div style={{ width: "50%" }}>
                                            <RadioButton
                                                onChange={(value) => {

                                                    let vals = values;
                                                    let index = -1;
                                                    if (param) {
                                                        index = vals.indexOf(param);
                                                        param.paramValue = "1";
                                                        vals[index] = param;
                                                    } else {
                                                        vals.push({ paramValue: value, paramKey: reportParam.param.paramKey })
                                                    }
                                                    setValues([...vals])
                                                }}
                                                value={param?.paramValue === "1"}
                                                label={messages['report_overview_before']}
                                                position="end"
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    param && param.paramValue && param.paramValue !== -1 &&
                                    <div className="d-flex" style={{ marginTop: "15px" }}>

                                        <div style={{ width: "100%" }}>
                                            <InputDate
                                                id="input-date-after-before-creation"
                                                type="date"
                                                className="input-date-after-before-creation"
                                                onChange={(date) => {
                                                    let vals = values;
                                                    let index = -1;
                                                    if (paramDate) {
                                                        index = values.indexOf(paramDate);
                                                        paramDate.paramValue = date;
                                                        vals[index] = paramDate;
                                                    } else {
                                                        vals.push({ paramValue: date, paramKey: "afterBeforeCreationDate" })
                                                    }
                                                    setValues([...vals])

                                                }}
                                                value={valueParamDate}
                                            />
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </Fragment>
                )
                break;
            case "afterBeforeCreationDate":
                return (
                    <Fragment>

                    </Fragment>
                );
                break;
            case "orderBy":
                return (
                    <Fragment>

                    </Fragment>
                );
                break;
            case "orderCriteria":
                return (
                    <Fragment>

                    </Fragment>
                );
                break;
            case "eventType":
                let eventType = getEventsTypes(messages).find(x => x.id === param?.paramValue)
                if (eventType)
                    param.name = eventType.name

                return (
                    <Select
                        id="eventType-list"
                        label={messages[`report_overview_${reportParam?.param?.paramKey}`] || reportParam?.param?.name}
                        placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam?.param?.name] || reportParam?.param?.name}
                        value={param && param.paramValue && param.paramValue !== -1 ? param : null}
                        onChange={(value) => {
                            let vals = values;
                            let index = -1;
                            let valueId = -1;
                            if (value)
                                valueId = value.id;

                            if (param) {
                                index = vals.indexOf(param);
                                if (value) {
                                    param.paramValue = valueId;
                                    param.id = valueId;
                                    param.name = value.name
                                } else {
                                    param.paramValue = -1;
                                    param.id = -1;
                                    param.name = null;
                                }
                                vals[index] = param;
                            } else {
                                vals.push({ paramValue: valueId, paramKey: reportParam.param.paramKey, id: valueId, name: value.name })
                            }

                            setValues([...vals]);
                            setRecreateGrid(true);


                        }}
                        isLoading={loadingEntity}
                        options={getEventsTypes(messages)}
                        requiredMessage={messages['required_field']}
                        //sort="ASC"
                        textField="name"
                        valueField="id"
                        isClearable={!reportParam.required}
                        required={reportParam.required}
                    />
                );

            default:
                let type = "text";
                let maxLength = 80;
                let isNumeric = false;
                switch (reportParam.param.type) {
                    case "Text":
                        type = "text";
                        maxLength = 80;
                        break;

                    case "Integer":
                        type = "number";
                        maxLength = 20;
                        isNumeric = true;
                        break;
                    case "Float":
                        type = "number";
                        maxLength = 20;
                        isNumeric = true;
                        break;
                    case "Boolean":
                        type = "";
                        break;
                    default:
                        break;
                }

                if (reportParam.param.type === "DropDownList") {
                    let dropDownList = report?.properties?.DropDownLists?.find(x => x.param === reportParam?.param?.paramKey)
                    if (dropDownList) {
                        return (
                            <Select
                                id={`DDL_${reportParam.param.paramKey}`}
                                label={(!messages[dropDownList.label] || messages[dropDownList.label] === "") ? dropDownList.label : messages[dropDownList.label]}
                                placeholder={messages[dropDownList.label]}
                                value={param && param.paramValue && param.paramValue !== -1 ? param : null}
                                onChange={(value) => {
                                    let vals = values;
                                    let index = -1;
                                    if (param) {
                                        index = vals.findIndex(x => x.paramKey === param.paramKey);
                                        if (value) {
                                            param.paramValue = value.value;
                                            param.id = value.value;
                                            param.name = value.label;
                                            param.label = value.label;
                                        } else {
                                            param.paramValue = -1;
                                            param.id = -1;
                                            param.name = null;
                                        }
                                        vals[index] = param;
                                    } else {
                                        vals.push({ paramValue: value.value, paramKey: reportParam.param.paramKey, id: value.value, label: value.label })
                                    }
                                    setValues([...vals])

                                }}
                                options={dropDownList && dropDownList.items || []}
                                requiredMessage={messages['required_field']}
                                //sort="ASC"
                                textField="label"
                                valueField="value"
                                isClearable={!reportParam.required}
                                required={reportParam.required}
                            />
                        );
                    }

                } else if (reportParam.param.type === "Boolean") {
                    let value = false;
                    if (param && param.paramValue && param.paramValue === 1) {
                        value = true;
                    }
                    return (
                        <ToggleSwitch
                            id={reportParam.param.paramKey}
                            medium
                            blueToggle
                            optionLabels={[messages['common_yes'], messages['common_no']]}
                            label={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam.param.name] || reportParam?.param?.name}
                            checked={value}
                            onChange={(val) => {
                                let vals = values;
                                let index = -1;
                                if (param) {
                                    index = values.indexOf(param);
                                    param.paramValue = val ? 1 : -1;
                                    vals[index] = param;
                                } else {
                                    vals.push({ paramValue: val ? 1 : -1, paramKey: reportParam.param.paramKey })
                                }
                                setValues([...vals]);
                            }}
                        />
                    );
                } else if (reportParam.param.type === "Date" || reportParam.param.type === "DateTime") {
                    return (
                        <div className="report-filters-control report-filters-date-control">
                            <label className="input-normal-label">
                                {messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam.param.name] || reportParam.param.name}
                                {reportParam.required && <span className="text-danger"> *</span>}
                            </label>
                            <div className="report-filters-date-input">
                                <InputDate
                                    id="input-date-after-before-creation"
                                    type={reportParam.param.type === "Date" ? "date" : "datetime"}
                                    onChange={(date) => {
                                        let vals = values;
                                        let index = -1;
                                        if (param) {
                                            index = vals.indexOf(param);
                                            param.paramValue = date;
                                            vals[index] = param;
                                        } else {
                                            vals.push({ paramValue: date, paramKey: reportParam.param.paramKey })
                                        }
                                        setValues([...vals])
                                    }}
                                    value={param && param.paramValue && param.paramValue !== -1 ? new Date(param.paramValue) : null}
                                />
                            </div>
                        </div>
                    );

                } else if (reportParam.param.type === "DateRange" && reportParam.param.paramKey === "startDate") {
                    let valueEnd = values.find((item) => item?.paramKey === "endDate")
                    return (
                        <div className="report-filters-control report-filters-date-control">
                            <label className="input-normal-label">
                                {messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam.param.name] || reportParam.param.name}
                                {reportParam.required && <span className="text-danger"> *</span>}
                            </label>
                            <div className="report-filters-date-input">
                                <InputDate
                                    id="input-date-range"
                                    type="range"
                                    inputWidth="100%"
                                    placeholder={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam.param.name] || reportParam.param.name}
                                    onChange={(value) => {
                                        const { start, end } = value;
                                        let vals = values;
                                        let indexStart = -1;
                                        let indexEnd = -1;
                                        if (param) {
                                            indexStart = vals.findIndex(x => x.paramKey === "startDate");
                                            indexEnd = vals.findIndex(x => x.paramKey === "endDate");
                                            param.paramValue = start ? start : -1;
                                            let paramEnd = values.find(x => x.paramKey === "endDate")
                                            paramEnd.paramValue = end ? end : -1;
                                            vals[indexStart] = param;
                                            vals[indexEnd] = paramEnd;
                                        } else {
                                            vals.push({ paramValue: start ? start : -1, paramKey: "startDate" })
                                            vals.push({ paramValue: end ? end : -1, paramKey: "endDate" })
                                        }
                                        setValues([...vals])
                                    }}
                                    value={param ? param?.paramValue !== -1 ? new Date(param?.paramValue) : null : null}
                                    valueEnd={valueEnd ? valueEnd?.paramValue !== -1 ? new Date(valueEnd?.paramValue) : null : null}
                                    maxDate={new Date()}
                                />
                            </div>
                        </div>
                    );

                } else if (reportParam.param.paramKey !== "endDate") {
                    return (
                        <Input
                            type={type}
                            name={messages[`report_overview_${reportParam?.param?.paramKey}`] || messages[reportParam.param.name] || reportParam.param.name}
                            id={reportParam.param.paramKey}
                            label={messages[reportParam.param.name] ? messages[reportParam.param.name] : reportParam.param.name}
                            placeholder={messages[reportParam.param.name] ? messages[reportParam.param.name] : reportParam.param.name}
                            value={param && param.paramValue && param.paramValue !== -1 ? param.paramValue : null /* || reportParam.defaultValue */}
                            onChange={(value) => {

                                let vals = values;
                                let index = -1;
                                if (param) {
                                    index = vals.indexOf(param);
                                    param.paramValue = value;
                                    vals[index] = param;
                                } else {
                                    vals.push({ paramValue: value, paramKey: reportParam.param.paramKey })
                                }
                                setValues([...vals])
                            }}
                            maxLength={maxLength}
                            isNumeric={isNumeric}
                            required={reportParam.required}
                            requiredMessage={messages['required_field']}

                        />
                    );
                }
                break;
        }

    }

    useEffect(() => {
        openPanel && (!dealers || dealers?.length === 0) && dispatch(searchEntityRequest({ key: "dealers" }));
        openPanel && (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }))
        openPanel && (!deviceModels || deviceModels?.length === 0) && dispatch(searchEntityRequest({ key: "deviceModels" }))
        if (report?.reportKey === "video_review_bycompany") {
            let accountParam = values && values?.find(x => x.paramKey === "accountId");
            if (accountParam?.paramValue !== -1)
                dispatch(searchEntityRequest({ key: "subUsers", companyId: accountParam?.paramValue }));
        }
        if (report?.params?.find(x => x?.param?.paramKey === "tagIds"))
            dispatch(searchEntityRequest({ key: "tags" }))
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={"side-panel-button-white"}
        >
            <Grid
                className="report-filters-panel"
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={12}>
                    <label className="report-filters-title">{messages['report_overview_filters']}</label>
                </Grid>
                <Grid item xs={12}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            if (props.onValidSubmit) {
                                props.onValidSubmit();
                            }
                        }}
                    >
                        <div className="report-filters-form">
                            {
                                openPanel && report && report.reportParams &&
                                report.reportParams.map((dataItem, key) => {
                                    const inputControl = getInput(dataItem);
                                    if (!inputControl) return null;
                                    return (
                                        <Grid key={key} item xs={12} className="report-filters-row">
                                            {inputControl}
                                        </Grid>
                                    )
                                })
                            }
                            <Grid item xs={12} className="report-filters-actions">
                                <Button
                                    className="btn btn-dark-blue btn-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        requestSubmitAction("execute");
                                        formRef.current.submit();
                                    }}
                                    disabled={loading}
                                >
                                    {messages['report_overview_execute_report']}
                                </Button>
                            </Grid>
                            {props.onExportReport && (
                                <Grid item xs={12} className="report-filters-actions">
                                    <Button
                                        className="btn btn-dark-blue btn-block"
                                        style={{ backgroundColor: '#fff', color: '#2d3748', border: '1px solid #2d3748' }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            requestSubmitAction("export", "CSV");
                                            formRef.current.submit();
                                        }}
                                        disabled={loading || props.exportLoading}
                                    >
                                        {messages['report_overview_export_report']}
                                    </Button>
                                </Grid>
                            )}
                        </div>
                    </Form>
                </Grid>
            </Grid>
        </SidePanel>
    )
}
export default AdvancedFilters